
<div #myModal class="modal fade" id="modal-default" style="border-color: transparent;">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <br>
        <br>
     

        <h4 class="modal-title">Política de cambios</h4>
        <button type="button"  data-dismiss="modal" aria-label="Close" style="width: 48px;height: 48px;font-size: xx-large;border-style: none;background-color: transparent;" >
          <span style="color: #000000;padding-top: 0.5em;
padding-bottom: 0.5em;font-size: 35px;">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="border-color: rgb(0, 0, 0);border-style:solid;">
        
        <strong>POLÍTICAS DE CAMBIO.</strong><br>
                        ESTAS POLÍTICAS SON FUNCIONALES DE ACUERDO A LOS SIGUIENTES CASOS:<br>
                        1) Plazo para solicitar el cambio es en un rango de 10 días contando a partir de la fecha en que recibes el pedido.<br>
                        2) Productos ofertados no tienen cambios.<br>
                        3) El nuevo producto debe de ser del mismo valor o más alto  (solo se paga la diferencia).<br>
                        4) Todo cambio tiene costo de envío.<br>

                <strong> REQUISITOS:</strong><br>
                       
                        1) Conservar la caja y el empaque original de los productos.<br>
                        2) El producto debe estar limpio y en condiciones originales.<br>
                        3) Debe entregarse con sus etiquetas sin estar desprendidas y en el epaque original.<br>
                        
                        

      </div>
      <div class="modal-footer justify-content-center">
        
        <button type="button" class="btn btn-danger" (click)="OnIraCambios()" style="height: 48px;font-size: larger;">Estoy de acuerdo.</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->


  <aside class="main-sidebar sidebar-dark-primary elevation-4" >
    <!-- Brand Logo -->
     <br>
   
    <a href="#/inicio" class="brand-link" style="border-block-color:transparent" >
      <img src="./assets/dist/img/logo_andrea.png" height="54px" width="54px"  >
      <span class="brand-text font-weight-light" >&nbsp;www.andreagt.com</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">
      <!-- Sidebar user panel (optional) -->


      <!-- SidebarSearch Form -->
     

      <!-- Sidebar Menu -->
      <nav class="mt-2">
     
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
             
               <li class="nav-item" style="height: 48px;">
                <a  class="nav-link" style="height: 48px;">
                    <i class="nav-icon far fa-circle " style="color: #FBFF00;"></i>
                  <p style="font-size: 20px;padding-top: 0.7em;
padding-bottom: 0.7em" (click)="OnIraInicio()">Inicio</p>
                </a>
              </li>
             
    

              <li class="nav-item" style="height: 48px;">
                <a  class="nav-link">
                  <i class="nav-icon far fa-circle " style="color: #38FF45;"></i>
                  <p style="font-size: 20px;padding-top: 0.7em;
padding-bottom: 0.7em" (click)="OnIraPedidoCliente()"> Mis pedidos</p>
                </a>
              </li>

              <li class="nav-item" style="height: 48px;">
                <a  class="nav-link">
                  <i class="nav-icon far fa-circle " style="color: #FBFF00;"></i>
                  <p style="font-size: 20px;padding-top: 0.7em;
padding-bottom: 0.7em" (click)="OnAbrirPoliticaCambio()">Cambios</p>
               
                </a>
              </li>
             
               <li class="nav-item" >
                <a href="#" class="nav-link" style="height: 48px;">
                    <i class="nav-icon fas fa-columns" style="color: #FFFFFF;"></i>
                  <p style="font-size: 20px;height: 48px;padding-top: 0.7em;
padding-bottom: 0.7em">
                   
                    <i class="fas fa-angle-left right"></i>
                    Catálogo
                  </p>
                </a>
                <ul class="nav nav-treeview" >
                  <li class="nav-item"  *ngFor="let dato of categoriadto; let i=index" style="height: 48px;">
                    <a  class="nav-link" >
                      <i class="nav-icon far fa-circle " style="color: #FFFFFF;"></i>
                      <p  style="font-size: 18px;height: 48px;padding-top: 0.7em;
padding-bottom: 0.7em"  (click)="OnIraArticulos(dato.idCategoria)"  > {{dato.descripcion}}</p>
                    </a>
                  </li>
                 
                 
                </ul>
            </li>


            <li class="nav-item" style="height: 60px;">
              <a  class="nav-link">
                <i class="nav-icon far fa-circle " style="color: #38FF45;"></i>
                <p style="font-size: 19px;padding-top: 0.7em;
padding-bottom: 0.7em" (click)="OnIraPoliticas()"> Políticas Privacidad</p>
              </a>
            </li>


        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>

  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->
  </aside>

<!-- <aside class="main-sidebar sidebar-dark-primary elevation-4">

    <a href="" class="brand-link">
    
      <span class="brand-text font-weight-light">www.andreagt.com</span>
    </a>

   


    <div class="sidebar">
   
      

     

      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          
          
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="nav-icon fas fa-tree"></i>
              <p>
                Catálogo
                <i class="fas fa-angle-left right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <a  routerLink="categoria" class="nav-link" >
                  <i class="far fa-circle nav-icon"></i>
                  <p>Categoria</p>
                </a>
              </li>
              <li class="nav-item">
                <a href="pages/UI/icons.html" class="nav-link">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Marca</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="producto" class="nav-link" >
                  <i class="far fa-circle nav-icon"></i>
                  <p>Producto</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="gestion-pedido" class="nav-link" >
                  <i class="far fa-circle nav-icon"></i>
                  <p>Gestión pedidos</p>
                </a>
              </li>
              
             
            </ul>
          </li>
          
          
          <li class="nav-item">
            <a href="#/dashboard" class="nav-link" (click)="logout()">
              <i class="nav-icon fas fa-th"></i>
              <p>
               Salir
             
              </p>
            </a>
          </li>
          
          
         
        </ul>
      </nav>
     
    </div>
   
  </aside> -->